import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './EmptyCard.css';

const joinClasses = (first = '', second = '') => `${first} ${second}`;

const EmptyCard = ({ children, title, titleCentered, inactive }) => (
  <div
    className={joinClasses(
      title ? styles.cardWithTitle : styles.card,
      inactive ? styles.inactive : ''
    )}
  >
    <p
      className={joinClasses(
        titleCentered ? styles.centeredTitle : styles.title,
        inactive ? styles.inactiveTitle : ''
      )}
    >
      {title}
    </p>
    {children}
  </div>
);

EmptyCard.displayName = 'EmptyCard';

EmptyCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  title: PropTypes.string,
  titleCentered: PropTypes.bool,
  inactive: PropTypes.bool,
};

export default EmptyCard;



// WEBPACK FOOTER //
// ./src/components/EmptyCard.jsx